import React from 'react'
import healthcare1 from '../images/huckberry.png';
import healthcare2 from '../images/huckberry1.png';
import healthcare3 from '../images/coresync3.png';
import OurPartner from '../pages/components/OurPartner';

function Huckberry() {
    return (
        <>
            <section id="portfolio" className="container my-5">
                <div className="d-flex align-items-center justify-content-center text-center flex-wrap">
                    <div className="px-3 fw-bold responsive-heading">
                        <span className="highlight-orange">HuckBerry</span> – Customised E-commerce Platform 
                    </div>
                </div>
            </section>

            <section className="container my-5">
                {/* Section 1: Project Overview */}
                <div className="row g-0 overflow-hidden shadow rounded">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare1}
                            alt="Remente App Overview"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">HuckBerry</span> – Customised E-commerce Platform
                        </h1>

                        <p className="mb-3 ps-1">
                            HuckBerry is a fully customized e-commerce platform built to deliver a seamless shopping experience with high performance,
                            modern UI/UX, and optimized product management workflows. Designed to support scalable online retail operations, the platform
                            enables businesses to manage inventory, orders, customers, and storefront personalization efficiently.
                        </p>

                        <p className="mb-3 ps-1">
                            From advanced product filtering and dynamic catalog management to secure checkout, customer engagement tools,
                            and real-time analytics, HuckBerry provides a complete digital commerce ecosystem.
                            The platform helps brands enhance conversions, improve operational efficiency, and create a smooth,
                            user-friendly shopping journey across all devices.
                        </p>





                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>
                </div>

                {/* Section 2: Summary & Team Info */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3" style={{ fontSize: '3.2rem' }}>
                            <span className="highlight-orange">Client:</span> HuckBerry
                        </h1>

                        <h4 className="fw-bold mb-1 highlight-orange">Country</h4>
                        <p className="mb-3 ps-3">USA</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Technology & Purpose</h4>
                        <p className="mb-3 ps-3">
                            Custom E-commerce Engine, Product Catalog Management, Secure Checkout System, React, Node.js, Firebase,
                            REST APIs, Inventory Automation, Role-Based Access, Real-Time Sales & Customer Analytics Dashboard
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Domain</h4>
                        <p className="mb-3 ps-3">E-commerce Platform Development</p>

                        <h4 className="fw-bold mb-1 highlight-orange">Team Involvement</h4>
                        <p className="mb-3 ps-3">
                            UI/UX Designer, 2 Frontend Engineers, Backend Developer, Automation Specialist, Data Analyst, QA Engineer
                        </p>

                        <h4 className="fw-bold mb-1 highlight-orange">Duration</h4>
                        <p className="mb-4 ps-3">5 Months</p>

                        <p className="mb-4 ps-3">
                            HuckBerry is a fully customized e-commerce platform designed to deliver a fast, seamless, and intuitive online shopping experience.
                            The platform supports advanced product catalog management, smart inventory tracking, personalized recommendations, and a secure
                            multi-step checkout system. Built for modern retailers, HuckBerry enables businesses to streamline store operations, optimize
                            product discovery, and improve conversion rates.
                            With automation-driven processes, integrated analytics, and a modular backend architecture, the platform empowers brands to scale
                            effortlessly, manage customers efficiently, and run their entire e-commerce ecosystem with precision and flexibility.
                        </p>



                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Contact Us
                        </a>
                    </div>

                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare2}
                            alt="Remente UI"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>
                </div>

                {/* Section 3: Process & Key Features */}
                <div className="row g-0 overflow-hidden shadow rounded my-5">
                    <div className="col-12 col-md-5">
                        <img
                            src={healthcare3}
                            alt="Mental Wellness Features"
                            className="img-fluid w-100 h-100 object-fit-cover"
                        />
                    </div>

                    <div className="col-12 col-md-7 bg-light p-4 custom-rounded-end d-flex flex-column justify-content-center">
                        <h1 className="fw-bold mb-3">
                            <span className="highlight-orange">Process</span>
                        </h1>

                        <p className="mb-3 ps-1">
                            We built the HuckBerry platform with a commerce-first architecture designed for scalability, performance, and seamless product
                            management. The system integrates core e-commerce functionalities — including product cataloging, inventory syncing, order lifecycle
                            management, payment processing, and customer engagement — into a unified digital platform. The backend ensures fast API responses,
                            secure transactions, real-time stock updates, and smooth integration with third-party services such as payment gateways and logistics APIs.
                        </p>

                        <p className="mb-3 ps-1">
                            The UI/UX was crafted to deliver a premium shopping experience with intuitive navigation, minimal friction, and personalized content.
                            With clean product layouts, optimized checkout flows, and visually engaging visuals, HuckBerry makes online shopping effortless.
                            The admin dashboard was designed to give store managers full control — from managing products and inventory to tracking analytics
                            and processing orders with ease.
                        </p>

                        <h4 className="fw-bold mb-2 highlight-orange">Key Features</h4>
                        <ul className="ps-3 mb-4">
                            <li className="mb-1">Custom product catalog with advanced filtering & search</li>
                            <li className="mb-1">Real-time inventory management with auto-sync</li>
                            <li className="mb-1">Secure multi-step checkout with multiple payment gateways</li>
                            <li className="mb-1">Order lifecycle management: cart → order → shipping → delivery</li>
                            <li className="mb-1">Customer accounts with wishlists, history & personalized recommendations</li>
                            <li className="mb-1">Automated discounts, coupons & promotional campaign tools</li>
                            <li className="mb-1">Admin dashboard for product, order & customer management</li>
                            <li className="mb-1">Real-time sales analytics & customer insights for growth decisions</li>
                        </ul>

                        <a
                            href="/contact-us"
                            className="btn btn-orange rounded-pill px-4 py-2 fw-bold align-self-start"
                        >
                            Get Started
                        </a>
                    </div>
                </div>

                <OurPartner />
            </section>

        </>
    )
}

export default Huckberry